import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';

export const useDelete = () => {
  const { mutate: mutateDelete, isPending } = useAppMutation([QueryKey.DELETE_COMPANY], {
    mutationFn: ({ companyId }: { companyId: string }) =>
      ApiService.delete({ endpoint: BackendRoute.COMPANIES, routePath: [companyId] }),
  });

  return { deleteCompany: mutateDelete, isPending };
};
